import { jsx as _jsx } from "react/jsx-runtime";
import { useFeature } from 'flagged';
import loadable from '@loadable/component';
import Choice from '@components/UI/Choice/Choice';
import { getAccountLoginSocialMediaTypes } from '@domain/User/constants';
import getSocialMediaServiceNameFromType from '@helpers/SocialMedia/getSocialMediaServiceNameFromType';
import isMobileBrowser from '@helpers/isMobileBrowser';
import isMobileInAppBrowser from '@helpers/isMobileInAppBrowser';
import RegistrationDisabled from './Register/RegistrationDisabled';
const Icon = loadable(() => import('@components/UI/Icon/Icon'));
const isDisabledLoginMethodInInAppBrowser = (type) => ['facebook', 'google'].includes(type);
const AuthMethodSelector = ({ authAction, onSelect, className = '' }) => {
    const isSignupDisabled = !!useFeature('disable_user_signup');
    const availableTypes = [...getAccountLoginSocialMediaTypes(authAction), 'Email'];
    const labelPrefix = authAction === 'login' ? 'Log In with ' : 'Sign Up with ';
    const socialMediaAccountOptions = availableTypes.map((type) => ({
        id: type,
        value: type,
        label: _jsx("span", { children: `${labelPrefix} ${type === 'Email' ? 'Email' : getSocialMediaServiceNameFromType(type)}` }),
        icon: _jsx(Icon, { icon: type === 'Email' ? 'repeatlogo' : type, color: type === 'Email' ? 'primary' : type }),
        paletteName: 'primary',
        type,
        disabled: isMobileBrowser() && isMobileInAppBrowser() && isDisabledLoginMethodInInAppBrowser(type),
    }));
    if (authAction === 'register' && isSignupDisabled) {
        return _jsx(RegistrationDisabled, {});
    }
    return (_jsx(Choice, { className: className, choices: socialMediaAccountOptions, onSelect: (selected) => onSelect(selected), selectButtonLabel: "Choose how you want to signup", resolveChoiceMode: () => 'buttons' }));
};
export default AuthMethodSelector;
